import * as D from './deps';

export function getItems({ sinceVersion, cursor, limit }: $TSFixMe): $TSFixMe {
  D.Utils.Time.markTimeAtMoment(D.Constants.App.ApiCheckpointMarks.COLLECTIONS_GET_ITEMS_REQUEST);
  return D.apiRequest({
    endpoint: D.ApiEndpoints.COLLECTIONS_GET_ITEMS,
    content: {
      request: {
        sinceVersion,
        cursor,
        limit,
      },
    },
  });
}

export function addItem({ deviceInfoDTO, analyticsInfo, pandoraId }: $TSFixMe): $TSFixMe {
  return D.apiRequest({
    endpoint: D.ApiEndpoints.COLLECTIONS_ADD_ITEM,
    content: {
      deviceInfoDTO,
      request: {
        analyticsInfo,
        pandoraId,
      },
    },
  });
}

export function removeItem({
  deviceInfoDTO,
  analyticsInfo,
  pandoraId,
  redirectToMyMusicPlaylists = false,
}: $TSFixMe): $TSFixMe {
  return D.apiRequest({
    endpoint: D.ApiEndpoints.COLLECTIONS_REMOVE_ITEM,
    content: {
      deviceInfoDTO,
      request: {
        analyticsInfo,
        pandoraId,
      },
    },
    actionParams: {
      redirectToMyMusicPlaylists,
    },
  });
}

export function getSortedByTypes({
  sortOrder,
  offset,
  limit,
  annotationLimit,
  typePrefixes,
  collectionV7EndpointsEnabled,
}: $TSFixMe): $TSFixMe {
  if (collectionV7EndpointsEnabled) {
    // @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    const sortParams = D.v7SortingMap[sortOrder];

    return D.apiRequest({
      endpoint: D.ApiEndpoints.COLLECTIONS_GET_SORTED_BY_TYPES,
      content: {
        request: {
          ...sortParams,
          offset,
          limit,
          annotationLimit,
          typePrefixes,
        },
      },
    });
  }

  return D.apiRequest({
    endpoint: D.ApiEndpoints.COLLECTIONS_GET_SORTED_BY_TYPES_V6,
    content: {
      request: {
        sortOrder,
        offset,
        limit,
        annotationLimit,
        typePrefixes,
      },
    },
  });
}

export function getSortedPlaylists({
  sortOrder,
  offset,
  limit,
  annotationLimit,
  isRecentModifiedPlaylists = false,
  allowedTypes,
}: $TSFixMe): $TSFixMe {
  D.Utils.Time.markTimeAtMoment(
    D.Constants.App.ApiCheckpointMarks.COLLECTIONS_GET_SORTED_PLAYLISTS_REQUEST,
  );
  // getSortedPlaylists doesn't currently support MOST_RECENT_ADDED, so we need to change
  // it to MOST_RECENT_MODIFIED
  const sort = sortOrder === 'MOST_RECENT_ADDED' ? 'MOST_RECENT_MODIFIED' : sortOrder;
  const request = { sortOrder: sort, offset, limit, annotationLimit };
  return D.apiRequest({
    endpoint: D.ApiEndpoints.COLLECTIONS_GET_SORTED_PLAYLISTS,
    content: {
      request,
      isRecentModifiedPlaylists,
      allowedTypes,
    },
  });
}

export function getVersion(): $TSFixMe {
  return D.apiRequest({
    endpoint: D.ApiEndpoints.COLLECTIONS_GET_VERSION,
  });
}

export function getItemsByArtist({
  artistPandoraId,
  offset,
  limit,
  annotationLimit,
}: $TSFixMe): $TSFixMe {
  return D.apiRequest({
    endpoint: D.ApiEndpoints.COLLECTIONS_GET_ITEMS_BY_ARTIST,
    content: {
      request: {
        artistPandoraId,
        offset,
        limit,
        annotationLimit,
      },
    },
  });
}
